module.exports = __webpack_public_path__ + "img/swiper8.e59344b0.png";